<template>
  <div class="websites">
    <h1>Modifica Sito</h1>
      <div class="form">
        <div>
          <input type="text" name="name" placeholder="NOME" v-model="name">
        </div>
        <div>
          <input type="text" name="baseurl" placeholder="URL" v-model="baseurl">
        </div>
        <div>
          <input type="text" name="rule" placeholder="REGOLA" v-model="rule">
        </div>
        <div>
          <input type="checkbox" name="unformatthousands" placeholder="" v-model="unformatthousands"> ELIMINA SEPARATORE MIGLIAIA
        </div>
        <div>
          <input type="checkbox" name="decimalpoint" placeholder="" v-model="decimalpoint"> SEPARATORE DECIMALE PUNTO
        </div>
        <div>
          <input type="checkbox" name="addvat" placeholder="" v-model="addvat"> SITO IVA ESCLUSA
        </div>
        <div>
          <input type="checkbox" name="hidereport" placeholder="" v-model="hidereport"> NASCONDI DA REPORT
        </div>
        <div>
          <input type="checkbox" name="competitorsreport" placeholder="" v-model="competitorsreport"> REPORT CONCORRENTI
        </div>
        <div>
          <input type="checkbox" name="competitorstable" placeholder="" v-model="competitorstable"> TABELLA CONCORRENTI
        </div>
        <div>
          <input type="checkbox" name="error" placeholder="" v-model="error"> ERRORE
        </div>
        <div>
          <button class="app_btn" @click="updateWebsite">Salva</button>
        </div>
      </div>
  </div>
</template>

<script>
import WebsitesService from '@/services/WebsitesService'
export default {
  name: 'EditWebsite',
  data () {
    return {
        name: '',
        baseurl: '',
        rule: '',
        unformatthousands: false,
        decimalpoint: false,
        hidereport: false,
        error: false,
        addvat: false
    }
  },
  mounted () {
    this.getWebsite()
  },
  methods: {
    async getWebsite () {
      const response = await WebsitesService.get({
        id: this.$route.params.id
      })
      this.name = response.data.name
      this.baseurl = response.data.baseurl
      this.rule = response.data.rule
      this.unformatthousands = response.data.unformatthousands
      this.decimalpoint = response.data.decimalpoint
      this.error = response.data.error
      this.hidereport = response.data.hidereport
      this.competitorsreport = response.data.competitorsreport
      this.competitorstable = response.data.competitorstable
      this.addvat = response.data.addvat
    },
    async updateWebsite () {
      await WebsitesService.update({
        id: this.$route.params.id,
        name: this.name,
        baseurl: this.baseurl,
        rule: this.rule,
        unformatthousands: this.unformatthousands,
        decimalpoint: this.decimalpoint,
        error: this.error,
        hidereport: this.hidereport,
        competitorsreport: this.competitorsreport,
        competitorstable: this.competitorstable,
        addvat: this.addvat
      })
      this.$router.push({ name: 'Websites' })
    }
  }
}
</script>
<style type="text/css">
.form input, .form textarea {
  width: 100%;
  max-width: 500px;
  padding: 10px;
  border: 1px solid #e0dede;
  outline: none;
  font-size: 12px;
}
.form input[type=checkbox] {
    width: auto;
}
.form div {
  margin: 20px;
}
.app_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  max-width: 500px;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EditWebsite.vue